import React from "react";
import { ServiceRejections } from "../../types/serviceDetail";

interface Props {
  serviceRejection: ServiceRejections[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceRejection: React.FC<Props> = ({
  serviceRejection,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const HeadingTag = isPage ? "h3" : "p";

  return (
    <div className="py-4">
      {sectionTitle && (
        <HeadingTag
          className="text-center font-16 text-black ff-semibold mb-4"
          dangerouslySetInnerHTML={{ __html: sectionTitle }}
        />
      )}
      {line && (
        <p className="font-12 text-grey ff-normal text-center">{line}</p>
      )}
      <div className="rejection-wrap-main">
        {serviceRejection.map((rejection, index) => (
          <div
            key={`rejection-${index}`} // Key moved to outer div
            className="d-flex align-items-center justify-content-start gap-3 layout-border p-2 rounded mb-2 rejection rejection-main-each"
          >
            <div className="d-flex align-items-start gap-3 px-2 rejection align-items-center">
              {rejection.icon && (
                <img src={rejection.icon} alt={rejection.title ?? ""} />
              )}
              <div>
                <HeadingTag
                  className="font-14 ff-bold text-black mb-1"
                  dangerouslySetInnerHTML={{ __html: rejection.title ?? "" }}
                />
                <p
                  className="font-12 ff-medium text-grey mb-1"
                  dangerouslySetInnerHTML={{
                    __html: rejection.description ?? "",
                  }}
                ></p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceRejection;
